module.exports = __webpack_public_path__ + "static/cal-king-4d8bb0c36c70111188daabb96c18f65e.png";